import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, Router } from '@angular/router';
import { RbacService } from './services/rbac.service';
import { Permission } from './lib/rbac.config';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate, CanActivateChild {
    constructor(private rbac: RbacService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        return this.check(route);
    }

    canActivateChild(route: ActivatedRouteSnapshot): boolean {
        return this.check(route);
    }

    private check(route: ActivatedRouteSnapshot): boolean {
        const required = route.data['permission'] as Permission | Permission[] | undefined;
        if (!required) return true; // no permission declared = just needs to be logged in

        const allowed = Array.isArray(required)
            ? this.rbac.hasAnyPermission(required)
            : this.rbac.hasPermission(required);

        if (!allowed) {
            this.router.navigate(['/access-denied']);
            return false;
        }
        return true;
    }
}
